import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';

export const Menu = styled(AntMenu)`
  padding: 10px;
  border-radius: 5px;
  background-color: var(--clr-container-bg);
`;
